"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getAppconfig = getAppconfig;
var _effects = require("redux-saga/effects");
var actions = _interopRequireWildcard(require("../actions"));
var _SessionStorage = _interopRequireDefault(require("../../shared/SessionStorage"));
var _constants = _interopRequireDefault(require("../constants"));
var _snacks = require("../services/snacks");
var _appconfig = require("../utils/appconfig");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function* getAppconfig() {
  try {
    const appconfigAPI = yield (0, _effects.getContext)('appconfigApi');
    const rawAppconfig = yield (0, _effects.call)(appconfigAPI.getAppconfig);
    const appconfig = yield (0, _effects.call)(_appconfig.prepareAppconfig, rawAppconfig);
    yield (0, _effects.put)(actions.getAppconfigSuccess(appconfig));
    _SessionStorage.default.set(_constants.default.APPCONFIG, {
      header: appconfig.header,
      menu: appconfig.menu,
      hiddenMenu: appconfig.hiddenMenu,
      collapsedMenu: appconfig.collapsedMenu,
      headerBasedSitemap: appconfig.headerBasedSitemap,
      isEmailTrackingEnabled: appconfig.isEmailTrackingEnabled
    });
    if (appconfig.collapsedMenu !== undefined && _SessionStorage.default.get(_constants.default.MENU_EXPANDED) === null) {
      yield (0, _effects.put)(actions.toggleMenu(!appconfig.collapsedMenu));
    }
  } catch (error) {
    const locale = yield (0, _effects.getContext)('locale');
    yield (0, _effects.put)(actions.getAppconfigError(error.message));
    yield (0, _effects.put)(actions.setSnack((0, _snacks.errorSnack)(locale.appconfigAPIError || error.message)));
  }
}
function _default() {
  return (0, _effects.all)([(0, _effects.takeLatest)(actions.GET_APP_CONFIG_PENDING, getAppconfig)]);
}